/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplyCompanyToSilverAmbassadorRequest } from '../../models/apply-company-to-silver-ambassador-request';

export interface ApplyCompanyToSilverAmbassador$Params {
      body: ApplyCompanyToSilverAmbassadorRequest
}

export function applyCompanyToSilverAmbassador(http: HttpClient, rootUrl: string, params: ApplyCompanyToSilverAmbassador$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, applyCompanyToSilverAmbassador.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

applyCompanyToSilverAmbassador.PATH = '/api/apply-company-to-silver-ambassador';
